import type { EditorCommand } from '@atlaskit/editor-common/types';
import FeatureGates from '@atlaskit/feature-gate-js-client';

import { parseMauiDiagramLink } from '../pm-plugins/detect-maui-link';
import { ActionType, mauiDiagramPastePluginKey } from '../pm-plugins/maui-diagram-paste-plugin';

type MauiEmbedSpacePickerCommandArgs = {
	contentId?: string;
	originalUrl?: string;
};

const getMauiEmbedContentId = ({
	contentId,
	originalUrl,
}: MauiEmbedSpacePickerCommandArgs): string | undefined =>
	contentId ?? (originalUrl ? parseMauiDiagramLink(originalUrl)?.contentId : undefined);

export const openMauiEmbedSpacePickerCommand =
	(args: MauiEmbedSpacePickerCommandArgs): EditorCommand =>
	({ tr }) => {
		if (
			// eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- dynamic config killswitch, not a standard feature gate
			FeatureGates.getExperimentValue<boolean>(
				'maui-native-embed-finalize-diagram-anywhere',
				'value',
				false,
			)
		) {
			return null;
		}

		const contentId = getMauiEmbedContentId(args);
		if (!contentId) {
			return null;
		}

		tr.setMeta(mauiDiagramPastePluginKey, {
			type: ActionType.EMBED_FINALIZE_OPEN_PICKER,
			contentId,
		});
		return tr;
	};

export const closeMauiEmbedSpacePickerCommand =
	(args: MauiEmbedSpacePickerCommandArgs): EditorCommand =>
	({ tr }) => {
		if (
			// eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- dynamic config killswitch, not a standard feature gate
			FeatureGates.getExperimentValue<boolean>(
				'maui-native-embed-finalize-diagram-anywhere',
				'value',
				false,
			)
		) {
			return null;
		}

		const contentId = getMauiEmbedContentId(args);
		if (!contentId) {
			return null;
		}

		tr.setMeta(mauiDiagramPastePluginKey, {
			type: ActionType.EMBED_FINALIZE_CLOSE_PICKER,
			contentId,
		});
		return tr;
	};
